import React from 'react';

import { Paper, Typography } from '@mui/material';

import {
  OrganizationMenusPage,
  SiteMenusPage,
} from './components';

export interface MenusPageProps {
  organizationId?: number;
  siteId?: number;
}

export function MenusPage({ organizationId, siteId }: MenusPageProps) {
  if (siteId && siteId > 0) {
    return <SiteMenusPage siteId={siteId} />;
  }

  if (organizationId) {
    return <OrganizationMenusPage organizationId={organizationId} />;
  }

  return (
    <Paper sx={{ p: 4 }} elevation={0}>
      <Typography align="center" color="text.secondary">
        Select a property or organization to view menus.
      </Typography>
    </Paper>
  );
}
